export default {
  methods: {
    multipleMutate(mutate: any, variablesArr = []) {
      variablesArr.map(variables => mutate({ variables }));
    }
  }
};
